import Vue from 'vue';

import Kariera from './components/kariera/Kariera.vue'

console.log("kariera.js");

new Vue({
  // router,
  components: {
    'kariera': Kariera,
  }
}).$mount('#karieraApp')